import React from "react";
import { FaSpotify, FaYoutube, FaInstagram, FaTiktok } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="relative text-white overflow-hidden bg-gradient-to-b from-[#0f0f0f] via-[#141414] to-[#1c1c1c]">
      {/* GLOW EFFECT */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-pink-500/10 blur-[120px] rounded-full" />

      {/* BACKGROUND IMAGE */}
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/kalia/footer.jpg')",
        }}
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" />

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* BRAND */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Kalia Siska</h2>
            <p className="text-gray-400 text-sm leading-relaxed">Penyanyi dangdut & DJ kentrung dengan sentuhan ska reggae yang unik. Dikenal melalui berbagai cover viral di YouTube dan performa energik yang khas.</p>
          </div>

          {/* NAVIGATION */}
          <div>
            <h3 className="font-semibold mb-4">Menu</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <NavLink to="/" className="hover:text-white transition">
                  Beranda
                </NavLink>
              </li>
              <li>
                <NavLink to="/informasi" className="hover:text-white transition">
                  Informasi
                </NavLink>
              </li>
              <li>
                <NavLink to="/music" className="hover:text-white transition">
                  Explore Music
                </NavLink>
              </li>
              <li>
                <NavLink to="/galeri" className="hover:text-white transition">
                  Galeri
                </NavLink>
              </li>
              <li>
                <NavLink to="/kontak" className="hover:text-white transition">
                  Kontak
                </NavLink>
              </li>
            </ul>
          </div>

          {/* SOCIAL + SPOTIFY */}
          <div>
            <h3 className="font-semibold mb-4">Follow & Listen</h3>

            {/* SOCIAL ICON */}
            <div className="flex gap-4 mb-6">
              <Link to="https://open.spotify.com/artist/70hsEvlt6YZPT97UIvzpEu" target="_blank" className="bg-green-500 p-3 rounded-full hover:scale-110 hover:shadow-[0_0_15px_rgba(34,197,94,0.6)] transition">
                <FaSpotify />
              </Link>
              <Link to="https://www.youtube.com/results?search_query=kalia+siska+official" className="bg-red-500 p-3 rounded-full hover:scale-110 hover:shadow-[0_0_15px_rgba(239,68,68,0.6)] transition">
                <FaYoutube />
              </Link>
              <Link to="https://www.instagram.com/kaliasiska86/" target="_blank" className="bg-pink-500 p-3 rounded-full hover:scale-110 hover:shadow-[0_0_15px_rgba(236,72,153,0.6)] transition">
                <FaInstagram />
              </Link>
              <Link to="https://www.tiktok.com/@kaliasiska_" target="_blank" className="bg-gray-500 p-3 rounded-full hover:bg-gray-600 hover:scale-110 hover:shadow-[0_0_15px_rgba(107,114,128,0.6)] transition">
                <FaTiktok />
              </Link>
            </div>

            {/* SPOTIFY EMBED */}
            <iframe src="https://open.spotify.com/embed/artist/70hsEvlt6YZPT97UIvzpEu" width="100%" height="80" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className="rounded-xl" />
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="border-t border-white/10 mt-12 pt-6 text-center text-gray-500 text-sm">
          © 2026 <span className="text-pink-400">Kalia Siska.</span> All rights reserved. <br />
          <span>
            Powered By <span className="font-semibold">PT.Jejak Digital Teknologi</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
